import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ErrorData, ErrorDataOptions } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../models/fact-mapping.interface';
import { FactResult } from '../../models/fact-result.model';

@Injectable({
	providedIn: 'root'
})
export class FactGeneratorHelper {
	/**
	 * utility method to extract the fact value from with the extractor from mapping config
	 * @param fact fact name, should exist in one of the factMappingConfig
	 * @param portfolioStoreData map of stores and single portfolio data
	 * @param factMappingConfig config to be inject, all the facts are available in facts sub folder
	 * @param contentService content service instance
	 */
	public extractValue(fact: string, portfolioStoreData: { [storeName: string]: any }, factMappingConfig: any, contentService: ContentService): FactResult {
		try {
			const factConfig: FactMappingInterface = factMappingConfig[fact];
			if (!factConfig) {
				return new FactResult(
					null,
					ErrorData.create({
						id: 'FACT_GENERATOR_ERROR',
						success: false,
						allDataReturned: false,
						errorCodes: ['FACT_MAPPING_ERROR'],
						failureReason: 'Error occurred, fact does not exist',
						debugMessage: fact + ' does not exist in mapping'
					} as ErrorDataOptions)
				);
			}
			return factConfig.extractor.extract(portfolioStoreData, contentService);
		} catch (error) {
			return new FactResult(
				null,
				ErrorData.create({
					id: 'FACT_GENERATOR_ERROR',
					success: false,
					allDataReturned: false,
					errorCodes: ['FACT_MAPPING_ERROR'],
					failureReason: 'Unknown error occurred',
					debugMessage: 'Error with message:' + (<Error>error).message
				} as ErrorDataOptions)
			);
		}
	}
}
